module.exports = __webpack_public_path__ + "img/1. Greening the Philippine pandemic response.87503792.jpg";